import { ColourPaletteSuggestions } from "./colour-palette-suggestions";
import { ColourWheel } from "./colour-wheel";
import { GeneratePaletteButton } from "./generate-palette-button";
import { ColourChip } from "~/react/components/colour-palette/colour-chip";
import { useColourPaletteStore } from "~/js/stores/colour-palette-store";
import { useState } from "react";

export function ColourPaletteGenerator() {
  const [selectedColour, setSelectedColour] = useState("");
  const colourCode = useColourPaletteStore((state) => state.colourCode);

  const generatePalette = () => {
    setSelectedColour(colourCode);
  };

  return (
    <div className="colour-palette-generator">
      <div className="colour-palette-generator__wrapper">
        <ColourWheel />
        <ColourChip/>
      </div>
      <GeneratePaletteButton clickHandler={generatePalette}/>
      <ColourPaletteSuggestions colourCode={selectedColour}/>
    </div>
  );
}
